<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">アイコン情報編集</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h1>アイコン情報</h1>
          <div class="column-list">
            <label class="list-input-title">アイコンコード</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1508Model.iconCode" [style.width.rem]="3" readonly>
            </div>
            <label class="list-input-title">アイコン名</label>
            <div class="list-input-content">
              <input type="text" class="text-label-required" [(ngModel)]="kymw1508Model.iconName" [style.width.rem]="22" [maxLength]="20"
                plessInputTextSub [restrict]="'[ -￮]'" [fullOnly]="true">
            </div>
            <label class="list-input-title">グループ</label>
            <div class="list-input-content">
              <app-versatile-combo-box [listSource]="kymw1508Model.markGroupList" valueField="MarkGroupCode" labelField="Caption" [disabled]="false"
                [required]="true" [width]="200" [height]="20" [tabindex]="0" [visible]="true" [autofocus]="false" [blank]="true"
                forcedEnabledMode="true" [(ngModel)]="kymw1508Model.iconGroup" (change)="eventIconGroup_CHANGEHandler()">
              </app-versatile-combo-box>
            </div>
            <label class="list-input-title">アイコン区分</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_IconDiv" #cmb_IconDiv [subid]="'cmb_IconDiv'"
                [codeDiv]="'ctp050'" [forcedEnabledMode]="'true'" [style.width.px]="200"
                [tabindex]="0" [required]="true" [(ngModel)]="kymw1508Model.iconDiv">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">配置区分</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_ArrangeDiv" #cmb_IconDiv [subid]="'cmb_ArrangeDiv'"
                [codeDiv]="'ctp051'" [forcedEnabledMode]="'true'" [style.width.px]="200"
                [tabindex]="0" [required]="true" [(ngModel)]="kymw1508Model.arrangeDiv">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">アイコン説明</label>
            <div class="list-input-content">
              <input type="text" class="text-label-required" [(ngModel)]="kymw1508Model.iconExplain" [style.width.rem]="22" [maxLength]="20"
                plessInputTextSub [restrict]="'[ -￮]'" [fullOnly]="true">
            </div>
            <label class="list-input-title">出力区分</label>
            <div class="list-input-content">
              <app-checkbox-label #chb_Category label="商品マスタ" id="chb_Category" [(ngModel)]="kymw1508Model.category"
                [subid]="'chb_Category'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
              <app-checkbox-label #chb_Weekly label="ウィークリー" id="chb_Weekly" [(ngModel)]="kymw1508Model.weekly"
                [subid]="'chb_Weekly'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
              <app-checkbox-label #chb_Daily label="デイリー" id="chb_Daily" [(ngModel)]="kymw1508Model.daily"
                [subid]="'chb_Daily'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
              <app-checkbox-label #chb_Logistics label="見切り品" id="chb_Logistics" [(ngModel)]="kymw1508Model.logistics"
                [subid]="'chb_Logistics'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
              <app-checkbox-label #Order label="注文確認画面表示対象フラグ" id="chb_Order" [(ngModel)]="kymw1508Model.order"
                [subid]="'chb_Order'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_setting" class="btn-primary" (click)="eventSetting_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
